import { __assign } from "tslib";
import classnames from 'classnames';
import React, { useContext, useRef } from 'react';
import { ThemeOptions } from './constants';
import isEqual from 'react-fast-compare';
export function getGlobalClassnamesForContext(_a) {
    var isMobile = _a.isMobile, theme = _a.theme, isSisu = _a.isSisu, _b = _a.flags, flags = _b === void 0 ? {} : _b, themeSkin = _a.themeSkin;
    return classnames(isMobile && 'mobile', !isSisu && "theme-" + (theme || ThemeOptions.DARK).toString(), isSisu && 'sisu', themeSkin && themeSkin, flags['outline_buttons'] && 'outline-buttons');
}
export function getForcedGlobalClassnamesForContext(_a) {
    var theme = _a.theme;
    return "theme-" + theme + " forced-theme-" + theme;
}
export function getComponentName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// Helper to create a context provider component that instead of replacing
// parent values, it merges them with the provided ones
export function createMergingContextProvider(context, displayName) {
    if (displayName === void 0) { displayName = (context.displayName || 'Context') + "Provider"; }
    var MergingContextProvider = function (_a) {
        var children = _a.children, value = _a.value;
        var parentContext = useContext(context);
        var merged = useDeepEqualMemo(__assign(__assign({}, parentContext), value));
        return React.createElement(context.Provider, { value: merged }, children);
    };
    MergingContextProvider.displayName = displayName;
    return MergingContextProvider;
}
// TODO move to global shared hooks package
// This hook memoizes a value passed based on deep equality.
// Note that it doesn't save you on calculation time like useMemo,
// and it can get slow on huge objects. However it can help you avoid
// re-renders by keeping the value reference identical.
export function useDeepEqualMemo(value) {
    var memoizedValue = useRef(value);
    // only update the value if it's not deep equal
    if (!isEqual(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
//# sourceMappingURL=helpers.js.map